export enum PromptType {
  WeddingToastSpeech = 'WeddingToastSpeech',
  LoveStoryForWeddingWebsite = 'LoveStoryForWeddingWebsite',
  RegistryGiftSuggestions = 'RegistryGiftSuggestions',
  WeddingHashtagIdeas = 'WeddingHashtagIdeas',
  WeddingVows = 'WeddingVows',
  ThankYouNote = 'ThankYouNote',
  PoliteDeclineToAnInvitation = 'PoliteDeclineToAnInvitation',
}

export enum FieldName {
  styleOf = 'styleOf',
  givenBy = 'givenBy',
  story = 'story',
  meetingPlace = 'meetingPlace',
  whenStory = 'whenStory',
  emphasisOn = 'emphasisOn',
  names = 'names',
  location = 'location',
  sharedValues = 'sharedValues',
  loveMost = 'loveMost',
  toPerson = 'toPerson',
  forInput = 'forInput',
}

export enum FormType {
  SELECT = '0',
  INPUT = '1',
}

export interface SelectFieldValue {
  label: string;
  value: string;
}

export interface WriteMySubfieldsState {
  name: FieldName;
  label: string;
  value: string;
}

export interface SelectField {
  name: FieldName;
  label: string;
  type: FormType.SELECT;
  values: SelectFieldValue[];
}

export interface InputField {
  name: FieldName;
  label: string;
  type: FormType.INPUT;
  placeholders?: string[];
}

export type Field = SelectField | InputField;

export interface FormBody {
  name: PromptType;
  displayText: string;
  fields: Field[];
}

export interface FormDataFieldState {
  value: SelectFieldValue;
  index: number;
}
